import React, { useEffect, useState } from 'react';
import { useSharePanelStore } from 'src/common/store/share.store';
import { SignatureStrongIcon } from 'src/monet/icons';

import { apiGetAllNdaSignatures } from 'src/utils/journeyApi';

export const ShareConfigAccessSignaturesPanel = () => {
  const activeAlias = useSharePanelStore((state) => state.activeAlias);
  const [ndas, setNdas] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (activeAlias?.uuid) {
      setLoading(true);
      apiGetAllNdaSignatures(activeAlias.uuid).then((res) => {
        const { signed_ndas } = res;
        setNdas(signed_ndas);
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });
    }
  }, [activeAlias?.uuid]);

  if (!loading && ndas.length === 0) {
    return (
      <div>
        <div className="text-bedrock-p text-bedrock-black">
          No signatures captured. Copies of signed documents will appear here
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      {ndas.map((nda: any) => (
        <div className="p-2 hover:bg-bedrock-light-gray rounded-lg">
          <a href={nda.signed_document_url} target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2">
            <div className="w-10 h-10 rounded-md flex flex-shrink-0 bg-bedrock-brand-primary items-center justify-center">
              <SignatureStrongIcon className="text-bedrock-brand-text" />
            </div>
            <div className="flex flex-col">
              <div className="text-bedrock-p text-bedrock-black">
                {nda.email}
              </div>
              <div className="text-bedrock-p text-bedrock-dark-gray">
                {nda.created_at}
              </div>
            </div>
          </a>
        </div>
      ))}      
    </div>
  );
};
